import { render } from "./CoachDetail.vue?vue&type=template&id=1617b3ac"
import script from "./CoachDetail.vue?vue&type=script&lang=js"
export * from "./CoachDetail.vue?vue&type=script&lang=js"
script.render = render

export default script